<template>
  <confirmation-modal />
  <NotificationComponent />
  <router-view v-if="!this.isAuthenticated || $route.name == 'SignIn'" />
  <div v-else class="bg-light vh-100 d-flex flex-column">
    <NavbarComponent class="d-print-none" @toggle-sidebar="toggleSidebar" />
    <div class="app-wrapper flex-grow-1 px-3 py-3">
      <div class="d-flex h-100">
        <div
          class="d-flex align-items-center"
          v-if="isSidebarOpen || isDesktop"
        >
          <SidebarComponent
            class="d-print-none"
            @navigate="handleSidebarNavigate"
          />
        </div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmationModal from "@/components/shared/ConfirmationModal";
import { mapActions, mapGetters } from "vuex";
import NavbarComponent from "@/components/shared/NavbarComponent";
import SidebarComponent from "@/components/shared/SidebarComponent";
import NotificationComponent from "@/components/shared/NotificationComponent";

export default {
  components: {
    NotificationComponent,
    SidebarComponent,
    NavbarComponent,
    ConfirmationModal,
  },
  data() {
    return {
      intervalId: null,
      isSidebarOpen: false,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated", "isAuthenticated"]),
    isDesktop() {
      return this.windowWidth >= 768;
    },
  },
  methods: {
    ...mapActions("auth", ["tokenSignIn"]),
    async checkTokenAndHandleRedirect() {
      const success = await this.tokenSignIn();
      if (!success) {
        this.$router.push("/signIn");
      }
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      this.isSidebarOpen = this.isDesktop;
    },
    handleSidebarNavigate() {
      if (!this.isDesktop) {
        this.isSidebarOpen = false;
      }
    },
  },
  mounted() {
    this.intervalId = setInterval(
      () => this.checkTokenAndHandleRedirect(),
      30000
    );
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.app-wrapper {
  height: calc(100vh - 70px);
}
</style>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.container {
  max-width: calc(90vw) !important;
}
</style>
